import React, { lazy } from 'react'
import { Route } from 'react-router'
import { EMPLOYMENT_CONTRACT_MENU_ITEM } from '@/modules/EmploymentContract/EmploymentContract'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Missing = lazy(() => import('./Missing'))
const IDIndex = lazy(() => import('./:id/Index'))
const PersonIndex = lazy(() => import('./person/:personId/Index'))

export const EmploymentContractRouter = React.memo(() => (
  <SubRouter loggedIn roles={[EMPLOYMENT_CONTRACT_MENU_ITEM]}>
    <Route index element={<Index />} />
    <Route path='missing' element={<Missing />} />
    <Route path='person/:personId' element={<PersonIndex />} />
    <Route path=':id/*' element={<IDIndex />} />
  </SubRouter>
))
